import { Box, Pressable } from "components/ui";
import React, { useState, useRef, useEffect } from "react";
import { Text, LayoutChangeEvent } from "react-native";

interface CollapsibleTextProps {
	text: string;
	maxLines?: number;
}

const CollapsibleText: React.FC<CollapsibleTextProps> = ({ text, maxLines = 3 }) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const [showButton, setShowButton] = useState(false);
	const [truncatedHeight, setTruncatedHeight] = useState(0);
	const [fullHeight, setFullHeight] = useState(0);

	const onLayoutTruncated = (event: LayoutChangeEvent) => {
		setTruncatedHeight(event.nativeEvent.layout.height);
	};

	const onLayoutFull = (event: LayoutChangeEvent) => {
		setFullHeight(event.nativeEvent.layout.height);
	};

	useEffect(() => {
		if (truncatedHeight > 0 && fullHeight > 0) {
			setShowButton(fullHeight > truncatedHeight);
		}
	}, [truncatedHeight, fullHeight]);

	return (
		<Box>
			<Text numberOfLines={isExpanded ? undefined : maxLines} onLayout={isExpanded ? onLayoutFull : onLayoutTruncated} style={{ color: "#000000" }}>
				{text}
			</Text>

			{/* Hidden text to measure full height */}
			<Text
				style={{
					position: "absolute",
					opacity: 0,
					color: "#000000",
				}}
				onLayout={onLayoutFull}
			>
				{text}
			</Text>

			{showButton && (
				<Pressable sx={{}} onPress={() => setIsExpanded(!isExpanded)}>
					<Text
						// @ts-ignore
						style={{
							marginTop: 8,
							color: "#0066CC",
							fontWeight: "500",
							borderBottomWidth: 1,
							borderBottomColor: "#0066CC",
							width: "fit-content",
						}}
					>
						{isExpanded ? "Read less" : "Read more"}
					</Text>
				</Pressable>
			)}
		</Box>
	);
};

export default CollapsibleText;
